/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DutyColumnKind = {
    Aw1: 'Aw1',
    Aw2: 'Aw2',
    Aw3: 'Aw3',
    Court: 'Court'
} as const;
export type DutyColumnKind = typeof DutyColumnKind[keyof typeof DutyColumnKind];


export function instanceOfDutyColumnKind(value: any): boolean {
    for (const key in DutyColumnKind) {
        if (Object.prototype.hasOwnProperty.call(DutyColumnKind, key)) {
            if (DutyColumnKind[key as keyof typeof DutyColumnKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DutyColumnKindFromJSON(json: any): DutyColumnKind {
    return DutyColumnKindFromJSONTyped(json, false);
}

export function DutyColumnKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyColumnKind {
    return json as DutyColumnKind;
}

export function DutyColumnKindToJSON(value?: DutyColumnKind | null): any {
    return value as any;
}

export function DutyColumnKindToJSONTyped(value: any, ignoreDiscriminator: boolean): DutyColumnKind {
    return value as DutyColumnKind;
}

